import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/**
 * Aprobarea de catre managerul solicitantului, pe un pas de flux
 * (`App\Easeedesk\Approval\ManagerApproval` in v4/api).
 *
 *   GET  /easeedesk/approvals                                "Awaiting my approval"
 *   POST /easeedesk/approvals/{id}/approve|reject            hotararea
 *   GET  /settings/easeedesk/workflow_settings/steps/{step}/approver
 *   POST /settings/easeedesk/workflow_settings/steps/{step}/approver
 *   GET  /settings/easeedesk/workflow_settings/{workflow}/approvers
 */

const SETTINGS = '/settings/easeedesk/workflow_settings'

export type StepApprover = '' | 'user_manager'

export interface StepApproverAnswer {
  approver: StepApprover
  options: { value: Exclude<StepApprover, ''>; label: string }[]
}

export function stepApproverQuery(step: number, enabled = true) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'workflow_settings', 'step_approver', step],
    queryFn: () => apiGet<StepApproverAnswer>(`${SETTINGS}/steps/${step}/approver`),
    enabled,
  })
}

export function saveStepApprover(step: number, approver: StepApprover) {
  return apiPostJson<{ ok?: boolean }>(`${SETTINGS}/steps/${step}/approver`, { approver })
}

export function workflowApproversQuery(workflow: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'workflow_settings', 'workflow_approvers', workflow],
    queryFn: () =>
      apiGet<{ steps: Record<string, { approver: StepApprover; label: string }> }>(`${SETTINGS}/${workflow}/approvers`),
    enabled: workflow > 0,
  })
}

export interface AwaitingApproval {
  id: number
  ticket: number
  subject: string
  summary: string
  company: string
  status: string
  status_color: string
  requester: string
  requested_at: string
  created: string
  /** De ce e omul pe cerere: managerul solicitantului, seful grupului, sau administrator (cerere fara aprobator). */
  as: 'manager' | 'team_manager' | 'administrator'
  note: string
}

export function myApprovalsQuery() {
  return queryOptions({
    queryKey: ['easeedesk', 'approvals', 'mine'],
    queryFn: () => apiGet<{ items: AwaitingApproval[]; admin: boolean }>('/easeedesk/approvals'),
  })
}

export function decideApproval(id: number, decision: 'approve' | 'reject', reason: string) {
  return apiPostJson<{ status?: string; message?: string }>(`/easeedesk/approvals/${id}/${decision}`, { reason })
}
